import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import StoreContainer from './components/storelocator/storeContainer';
import { sassOptOut } from '../utils/sassOptOut';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout } from './components/layout/DefaultLayout';

sassOptOut('forms');

const container = document.getElementById('store-app');
if (container) {
  const root = createRoot(container);
  root.render(
    <BaseContentProvider>
      <DefaultLayout>
        <StoreContainer />
      </DefaultLayout>
    </BaseContentProvider>
  );
}
